import { useMemo } from 'react';

/**
 * Hook to determine if expensive animations should be disabled.
 * Currently disables animations on Windows where they cause crashes.
 *
 * @returns true if animations should be disabled, false otherwise
 */
export const useDisableAnimations = (): boolean => {
  return useMemo(() => {
    if (typeof window === 'undefined' || !window.navigator) {
      return false;
    }

    const platform = window.navigator.platform.toLowerCase();
    const userAgent = window.navigator.userAgent.toLowerCase();

    // Disable animations on Windows to prevent performance issues and crashes
    return (
      platform.includes('win') ||
      userAgent.includes('windows') ||
      userAgent.includes('win32') ||
      userAgent.includes('win64')
    );
  }, []);
};
